<template>
  <div class="filter-set listing-types" :id="id">
    <button
      class="filter-name"
      @click.stop="$emit('toggle')"
      :class="getBoxClass()"
      tabindex="0"
      :aria-expanded="expanderVisible ? 'true' : 'false'"
      :aria-controls="id + '-listing-types-panel'"
      :id="id + '-listing-types-toggle'"
    >
      <span class="filter-name__label">Kohdetyyppi</span>
      <i class="toggle-expander icon-chevron-down"></i>
    </button>
    <expander :expanded="expanderVisible" v-if="featureGroupTypes">
      <div
        :id="id + '-listing-types-panel'"
        class="listing-types-panel"
        role="region"
        :aria-labelledby="id + '-listing-types-toggle'"
      >
        <div v-for="listingType in featureGroupTypes" class="form-checkbox" :key="`listing-type-${listingType.id}`">
          <Checkbox
            :id="checkboxId(listingType.id)"
            :label="listingType.name"
            :value="listingType.id"
            v-model="selectedTypesModel"
          />
        </div>
      </div>
    </expander>
  </div>
</template>

<script lang="ts">
import config from '@/config';
import Expander from '../expander/expander.vue';
import searchUtils from '@/app/utils/search-utils';
import { getFeatureGroupById } from '@/config/featureGroups';
import type { ListingTypesType } from '@/config/featureGroups';
import Checkbox from '@/app/components/form/checkbox.vue';
import type { PropType } from 'vue';

export default {
  name: 'listing-types',
  data: () => ({
    id: '',
  }),
  setup() {},
  props: {
    expanderVisible: {
      type: Boolean,
      default: undefined, // By default, the expander is visible but without any complex close/open css logic
    },
    selectedTypes: {
      type: Array as PropType<string[]>,
      default: () => [],
    },
    featureGroup: {
      type: String,
    },
  },
  methods: {
    getBoxClass() {
      return this.selectedTypes?.length ? 'in-use' : '';
    },
    checkboxId(n: ListingTypesType) {
      return `${this.id}-chk-${n}`;
    },
  },
  mounted() {
    this.id = this.$.uid.toString();
  },
  computed: {
    selectedTypesModel: {
      get() {
        return this.selectedTypes;
      },
      set(value: any) {
        const updates = { type: value };
        searchUtils.addFilterToUrl(this.$router, this.$route, updates);
      },
    },
    featureGroupTypes() {
      return getFeatureGroupById(this.featureGroup)?.types.map((id) => ({
        id,
        name: config.LISTING_TYPES[id].name,
      }));
    },
  },
  components: {
    Expander,
    Checkbox,
  },
};
</script>
